import { httpClient } from "@/services";
import { schedulesHeader } from "@/constants/defaultHeader";

export default {
	state: {
		schedulesList: [],
		schedulesFilterList: {},
		customers: [],
		schedulesSettingsDefault: null,
		schedulesSettings: null,
		schedulesHeaders: [],
	},
	mutations: {
		updateSchedulesSettingsAll(state, payload) {
			state.schedulesSettings = state.schedulesSettings.map(item => {
				item.settings = payload;
				return item;
			});
		},
		updateSchedulesSettingsReset(state) {
			state.schedulesSettings = state.schedulesSettingsDefault.map(item => ({ ...item }));
		},
		updateSchedulesList(state, payload) {
			const { schedules, filters, settings } = payload;
			state.schedulesList = schedules;
			state.schedulesFilterList = filters;

			if (settings && settings.length > 0) {
				state.schedulesSettingsDefault = settings;
				state.schedulesSettings = settings.map(item => ({ ...item }));
				state.schedulesHeaders = [];
				settings.map(item => {
					if (item.settings) {
						state.schedulesHeaders.push(item);
					}
				});
			} else {
				state.schedulesSettingsDefault = schedulesHeader;
				state.schedulesSettings = schedulesHeader.map(item => ({ ...item }));
				state.schedulesHeaders = [];
				schedulesHeader.map(item => {
					if (item.settings) {
						state.schedulesHeaders.push(item);
					}
				});
			}
		},
		updateCustomers(state, payload) {
			state.customers = payload;
		}
	},
	actions: {
		async onSchedulesSettingsSave({ dispatch, state }) {
			dispatch("actionPreloader", true);
			try {
				await httpClient.post('/schedules/settings', { settings: state.schedulesSettings });
				dispatch("actionPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},

		onSchedulesSettingsAll({ commit }, payload) {
			commit('updateSchedulesSettingsAll', payload);
		},
		onSchedulesSettingsReset({ commit }) {
			commit('updateSchedulesSettingsReset');
		},
		async getSchedulesList({ commit }) {
			try {
				const { data } = await httpClient.get('/schedules');

				if (data && !data.status) {
					commit('updateSchedulesList', data);
				}
			} catch (e) {
				console.error(e);
			}
		},
		async onSchedulesFilter({ commit }, values) {
			try {
				const { data } = await httpClient.post('/schedules/list', values);

				if (data && !data.status) {
					commit('updateSchedulesList', data);
				}
			} catch (e) {
				console.error(e);
			}
		},
		async getSchedulesItem(context, id) {
			try {
				const { data } = await httpClient.get(`/schedules/${ id }`);
				return data['load_files'];
			} catch (e) {
				console.error(e);
			}
		},
		async getSchedulesZip({ dispatch }, id) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.post(`/schedules/download/${ id }`);
				dispatch("actionPreloader", false);
				return data.file;
			} catch (e) {
				console.error(e);
			}
		},
		async createSchedule({ commit }) {
			try {
				const { data } = await httpClient.get('schedules/create');
				commit('updateCustomers', data.customer);
			} catch (e) {
				console.error(e);
			}
		},
		async onEditSchedule(context, id) {
			try {
				const { data } = await httpClient.get(`schedules/${ id }/edit`);
				return data;
			} catch (e) {
				console.error(e);
			}
		},
		async onSafeSchedules(context, data) {
			try {
				return await httpClient.post('schedules', data);
			} catch (e) {
				console.error(e);
			}
		},
		async onTotalEditSchedules(context, { id, data }) {
			try {
				return await httpClient.put(`schedules/${ id }`, data);
			} catch (e) {
				console.error(e);
			}
		},
		async onSentSchedules(context, data) {
			try {
				return await httpClient.post(`schedules/send/${ data.id }`, { emails: data.emails, message: data.message });
			} catch (e) {
				console.error(e);
			}
		}
	},
	getters: {
		schedulesList: (s) => s.schedulesList,
		schedulesFilterList: (s) => s.schedulesFilterList,
		customers: (s) => s.customers,
		schedulesSettingsDefault: (s) => s.schedulesSettingsDefault,
		schedulesSettings: (s) => s.schedulesSettings,
		schedulesHeaders: (s) => s.schedulesHeaders,
	},
};
